import { useState, useEffect, useCallback } from 'react';
import {apiPost} from '../api/AGIAPI';
import styled, {css, useTheme} from 'styled-components';

const HeaderContainer = styled.div`
    display: block;
    width: 100%;
    text-align: center;
    margin: 5rem auto;
    font-size: 1.5rem;
`;

function SignOutPage() {
	const [isLoading, setIsLoading] = useState(true);
	const [body, setBody] = useState(null);
	const theme = useTheme();


	const logout = useCallback( async () => {
		await apiPost('saml/logout', {})
			.then(() => {
				setBody(theme?.logout?.body);
				sessionStorage.clear();
			})
			.catch((err) => {
				setBody(theme?.logout?.error?.body);
			})
			.finally(() => {
				setIsLoading(false);
			});
	}, [theme?.logout]);

    useEffect(() => {
		setIsLoading(true);
		logout();
	}, [logout]);

	return (
		<>
			{!isLoading && (
                <HeaderContainer>
                    <p dangerouslySetInnerHTML={{ __html: body }}></p>
                    <p>
                        <a href='/'>{theme?.logout?.redirectText}</a>
                    </p>
                </HeaderContainer>
			)}
		</>
	);
}

export default SignOutPage;
